/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Pxk_Approved_AtInputs */

const vi_orders_pxk_approved_at = /** @type {(inputs: Orders_Pxk_Approved_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày duyệt`)
};

/**

* @param {Orders_Pxk_Approved_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const orders_pxk_approved_at = /** @type {((inputs?: Orders_Pxk_Approved_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pxk_Approved_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_orders_pxk_approved_at(inputs)
});